
export const IBibleOT = [
  'Gen', 'Exo', 'Lev', 'Num', 'Deu',
  'Jos', 'Jud', 'Rut', '1 Sam', '2 Sam', '1 Kng', '2 Kng',
  '1 Chr', '2 Chr', 'Ezr', 'Neh', 'Est', 'Job',
  'Psa', 'Pro', 'Ecc', 'SOS', 'Isa', 'Jer',
  'Lam', 'Eze', 'Dan', 'Hos', 'Joe', 'Amo', 'Oba',
  'Jon', 'Mic', 'Nah', 'Hab', 'Zep', 'Hag', 'Zec', 'Mal'
];
export const IBibleNT = [
  'Mtt', 'Mrk', 'Luk', 'Joh', 'Act', 'Rom', '1 Cor', '2 Cor',
  'Gal', 'Eph', 'Phi', 'Col', '1 Thes', '2 Thess',
  '1 Tim', '2 Tim', 'Tit', 'Phm', 'Heb', 'Jam', '1 Pet', '2 Pet',
  '1 Joh', '2 Joh', '3 Joh', 'Jud', 'Rev'
];

export const Iverses = [
  1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,
  40,41,42,43,44,45,46,47,48,49,50,51,52,53,54
]